import { decodeEventLog, zeroAddress, type Address, type Hex } from "viem";
import { ponsRewardNftABI } from "../../../abis/pons-reward-nft";
import { ELYSIUM, isElysiumFreePolicy } from "../../../config/elysium";

export function taskMintReceiptState(receipt: { logs: ReadonlyArray<{ address: Address; data: Hex; topics: readonly Hex[] }> },
  collection: string, wallet: string, tokenId: bigint, policyHash: string): "FINALIZED" | "PENDING_RANDOMNESS" | null {
  if (same(collection, ELYSIUM.collection) && !isElysiumFreePolicy("1", policyHash)) return null;
  let minted = false, finalized = false;
  for (const log of receipt.logs) {
    if (!same(log.address, collection)) continue;
    try {
      const event = decodeEventLog({ abi: ponsRewardNftABI, data: log.data, topics: [...log.topics] as [Hex, ...Hex[]] });
      if (event.eventName === "Transfer" && event.args.tokenId === tokenId && same(event.args.from, zeroAddress) && same(event.args.to, wallet)) minted = true;
      if (event.eventName === "RewardFinalized" && event.args.tokenId === tokenId) {
        if (!same(event.args.rewardPolicyHash, policyHash) || event.args.rewardBps < 5 || event.args.rewardBps > 10 || event.args.bandIndex > 4) return null;
        finalized = true;
      }
    } catch { /* Other collection logs do not establish task mint success. */ }
  }
  return minted ? finalized ? "FINALIZED" : "PENDING_RANDOMNESS" : null;
}

function same(a: string, b: string) { return a.toLowerCase() === b.toLowerCase(); }
